import { requestV3 , post} from '@/libs/ajax';
import qs from 'qs'
export function getConfigApi(params) {
    return requestV3({
        url: '/batch/get/conf',
        method: 'get',
        params
    })
}

/**
 * 获取产品
 * @param {*} data 
 * @returns 
 */
export function getBatchAppListApi(params) {
    return requestV3({
        url: '/batch/app/list?plat_id=10',
        method: 'get',
        params
    })
}

/**
 * 获取产品icon
 * @param {*} data 
 * @returns 
 */
export function getBatchProductIconApi(params) {
    return requestV3({
        url: '/batch/product/icon',
        method: 'get',
        params
    })
}
/**
 * 
 * @param {*} data 
 * @returns 
 */
export function genVideoCoverImg(data) {
    return post('/huawei_ads/batch/gen_video_cover_img', data)
}
/**
 * 效验产品
 * @param {*} data 
 * @returns 
 */
export function getBatchCheckProductnApi(params) {
    return requestV3({
        url: '/batch/check/product',
        method: 'get',
        params
    })
}

/**
 * 更新转化名称
 * @param {*} data 
 * @returns 
 */
export function postBatchPromotionVenusUpdateApi(data) {
    return requestV3({
        url: '/batch/promotion/venus/update',
        method: 'post',
        data: qs.stringify(data)
    })
}

/**
 * 批量创建生成预览 
 * @param {*} data 
 * @returns 
 */
export function postBatchAdsPreviewApi(data) {
    return requestV3({
        url: '/huawei/ads/batch/preview',
        method: 'post',
        data
    })
}

/**
 * 批量创建生成预览 
 * @param {*} data 
 * @returns 
 */
export function postBatchAdsSavaApi(data) {
    return requestV3({
        url: '/huawei/ads/batch/save',
        method: 'post',
        data: qs.stringify(data)
    })
}